var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import classNames from "classnames";
import { Heading, Paragraph } from "@riseart/common";
import { centeredSectionCls, centeredSectionBodyCls } from "./Centered.less";
var SectionCentered = /* @__PURE__ */ __name(function SectionCentered2(_ref) {
  var title = _ref.title, className = _ref.className, children = _ref.children;
  return /* @__PURE__ */ React.createElement("section", {
    className: classNames(centeredSectionCls, className)
  }, title ? /* @__PURE__ */ React.createElement(Heading, {
    tag: "h3",
    level: "5",
    align: "center"
  }, title) : null, children ? /* @__PURE__ */ React.createElement(Paragraph, {
    className: centeredSectionBodyCls
  }, children) : null);
}, "SectionCentered");
export {
  SectionCentered
};
